<template>
    <div class="send" :style="{minHeight:minHeight+'px'}" @click="hidedraft()">
        <!-- <router-view/> -->
        <headerCom></headerCom>
        <div class="send-content bg-white text-df" :style="{minHeight:minHeight+'px'}">
            <draftcover ref="collectcover" v-on:getdraftid="getdraftid"></draftcover>
            <div class="padding">
                <el-form ref="form" :model="form" :rules="rules" label-width="120px">

                    <el-form-item label="查询标题" prop="name">
                        <el-input v-model="form.name" placeholder="" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="查询文字提示" prop="tips">
                        <el-input type="textarea" v-model="form.tips"
                                  maxlength="100"
                                  placeholder="请输入正确的查询条件进行查询，忘记请联系组织者。"></el-input>
                    </el-form-item>
                    <el-form-item label="上传文档" prop="fileList">
                        <el-upload :auto-upload="false" :limit="1"
                                   :on-change="handleChange"
                                   :on-exceed="handleExceed"
                                   :show-file-list="true" accept=".xls, .xlsx"
                                   :file-list="form.fileList"
                                   class="upload-demo"
                                   action="/" :multiple="false">
                            <el-button size="small" type="primary">点此选择文档（xls、xlsx），10M以内</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="设置查询条件" prop="checked">
                        <el-select v-model="form.checked" multiple clearable
                                   @change="selectChange"
                                   placeholder="请选择">
                            <el-option
                                    v-for="(item,index) in tableHead"
                                    :key="index"
                                    :label="item.name"
                                    :value="index">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提交并生成查询</el-button>
                    </el-form-item>
                </el-form>


            </div>
        </div>
    </div>

</template>

<script>
  import headerCom from '../../components/header.vue'
  import draftcover from '../../components/draftcover.vue'
  import {read, utils} from 'xlsx'
  import App from '../../util/comfun'
  export default {
    //name: 'resultQuery',
    data() {
      var validateFile = (rule, value, callback) => {
        setTimeout(() => {
          //console.error('validateFile',{rule,value,fileList:this.fileList,tableHead:this.tableHead})
          if (value.length<1) {
            callback(new Error('请上传文档'));
          }else{
            if(this.tableHead.length<1 || this.tableData.length<1){
              callback(new Error('文档解析错误，请按标准处理表格'));
              setTimeout(()=>{
                this.form.fileList=[]
              },1000)
            }else{
              callback();
            }
          }
        }, 0);
      };
      return {
        minHeight: window.innerHeight - 82,
        tableHead: [],
        tableData: [],
        form:{
          fileList:[],
        },
        rules: {
          name: [
            {required: true, message: '请填写查询标题', trigger: 'blur'},
          ],
          tips:[
            { min: 0, max: 100, message: '最多 100 个字符', trigger: 'blur' }
          ],
          fileList: [
            { validator: validateFile, trigger: 'blur' },
          ],
          checked: [
            {required: true, message: '请设置查询条件', trigger: 'blur'},
          ],
        }
      }
    },
    components: {
      headerCom,
      draftcover,
    },
    methods: {
      getdraftid(obj) {
        console.log(obj)
        this.activityId = obj.id;
        this.hidedraft();
      },
      hidedraft() {
        this.$refs.collectcover.closedraft();
      },
      handleExceed(){
        this.$message({
          showClose: true,
          message: '删除已上传文件后，才能重新选择',
          type: 'error',
        });
      },
      // 导入成功时执行
      handleChange(file, fileList) {
        console.log('handleChange', file, fileList)
        // 将文件放入
        this.fileList=[file]
        //const files = {0: file};
        //if(!this.form.name) {this.form.name=file.name}
        this.form.checked=null
        this.form.fileList=this.fileList
        this.tableHead=[]
        this.tableData=[]
        this.readExcel(this.fileList);
      },
      readExcel(file) {
        const fileReader = new FileReader();

        fileReader.onload = ev => {
          try {
            const data = ev.target.result;
            const workbook = read(data, {type: "binary"});
            const params = [];
            // 取对应表生成json表格内容
            let json=utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])//二维表格
            // 重写数据
            if(json.length>0){
              Object.keys(json[0]).forEach(key=>{
                this.tableHead.push({
                  name:key,
                  useQuery:0,
                });
              })
              //return console.error(this.tableHead)
              json.forEach((row,rowIndex)=>{
                let arr=[]
                this.tableHead.forEach(head=>{
                  let val=row[head.name]||''
                  if(typeof val=='string'){
                    val=val.trim()
                  }
                  arr.push(val)
                })
                this.tableData.push(arr)
              })
            }
          } catch (e) {
            console.log("error:" + e);
            return false;
          }
        };
        fileReader.readAsBinaryString(file[0].raw);
      },
      selectChange(e){
        console.log(e)
        this.tableHead.forEach((row,rowIndex)=>{
          row.useQuery=0
          if(e.includes(rowIndex)){
            row.useQuery=1
          }
        })
//        console.log(JSON.stringify({
//          tableHead: this.tableHead,
//          tableData: this.tableData,
//        }))
      },
      onSubmit(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            let params={
              activityId:this.activityId,
              name:this.form.name,
              tips:this.form.tips,
              dataList:this.tableData,
              headList:this.tableHead,
            }
            //return console.log(params)
            this.loading = this.$loading({text: '处理中...', target: '.el-drawer'})
            App.demand('/activity/resultQuery/save','POST',params).then(res=>{
              this.loading.close()
              if(res.code!=200){
                return this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error',
                });
              }
              window.newData = {
                id:res.data?res.data.id:'debug',
                activityId:this.activityId,
              };
              this.$router.back()
            })
          }
        })
      },
    },
    mounted() {

    },

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/resultQuery/update.vue